<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('containerGroups.containerGroups'), name: 'company_container_groups' },
            {
              text: containerGroup.name,
              name: 'company_container_group',
              params: { container_group_uuid: $route.params.container_group_uuid },
            },
            { text: $t('containers.addEmptyingTemplate') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <EmptyingTemplateNewForm :afterSubmit="onSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs'
import EmptyingTemplateNewForm from '@/components/EmptyingTemplates/NewForm.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav.vue'

import containerGroupsApi from '@/api/containerGroups'
import emptyTemplatesApi from '@/api/emptyTemplates'

export default {
  name: 'newContainerGroupEmptyTemplate',
  components: {
    BreadCrumbs,
    CompanyNav,
    EmptyingTemplateNewForm,
    SectionHeader,
  },
  data: () => ({
    containerGroup: {},
  }),
  methods: {
    async getData() {
      const result = await containerGroupsApi.get(this.$route.params.container_group_uuid)
      this.containerGroup = result.success ? result.containerGroup : null
    },
    async onSubmit(newTemplateData) {
      const result = await emptyTemplatesApi.createToGroup(this.$route.params.container_group_uuid, newTemplateData)
      if (result.success) {
        await this.$router.push(`/company/container_groups/${this.$route.params.container_group_uuid}`)
      }
    },
  },
  async mounted() {
    await this.getData()
  },
}
</script>
